export default __webpack_public_path__ + "static/media/creditNote.e9646e7b.svg";